import Footer from "../../components/footer"
import { useTranslations } from "../../translations"
import Header from "../../components/protected/Header"
import LanguageSelector from "../../components/LanguageSelector"
import { BiInfoCircle, BiTrash } from "react-icons/bi"
import FileUpload from "../../components/protected/FileUpload"
import { Accordion } from "react-bootstrap"
import { generatePDF } from "../../components/utils/Pdf"
import { AiOutlineFilePdf } from "react-icons/ai"

const CreateText = ({ values }) => {
  const { t } = useTranslations()
  // En modo Bloom, "number" es POR CADA nivel: el total = number × niveles seleccionados.
  const numLevels = (values.isCheckedLevels || []).filter(Boolean).length
  const perLevel = Number(values.form.number) || 0
  const totalQuestions = perLevel * numLevels

  return (
    <div className="dashboard-wrapper">
      <Header />
      <main className="dashboard-main-content">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <div>
            <h1 className="dashboard-title mb-1">{values.title}</h1>
            <p className="text-muted">{t("createText")}</p>
          </div>
        </div>

        <div className="modern-card mb-5">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 text-center pt-3">
              <label htmlFor="format" className="form-label fw-bold fs-5 mb-4 color-plum">
                {t("selectFormat")}
              </label>
              <select
                className="form-select modern-select text-center"
                id="format"
                aria-label="Select format"
                value={values.form.format}
                onChange={values.handleChange}
                name="format"
              >
                <option value="-1">{t("select")}</option>
                <option value="open">{t("open")}</option>
                <option value="blooms">{t("bloomsTaxonomy")}</option>
              </select>
              <div id="helpText3" className="form-text mt-3">
                {t("formatHelp")}
              </div>
            </div>
          </div>
        </div>

        {values.form.format === "open" && (
          <div className="fade-in">
             <div className="modern-card mb-4" style={{ backgroundColor: 'rgba(235, 33, 120, 0.05)', border: '1px dashed var(--pink-bright)' }}>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <BiInfoCircle size="24" className="text-pink" />
                  <span className="fw-medium text-pink">{t("moduleInfo")}</span>
                </div>
              </div>

              <div className="modern-card">
                <form className="mx-auto" style={{ maxWidth: '800px' }} onSubmit={values.handleSubmit}>
                  <div className="mb-5">
                    <label htmlFor="text" className="form-label fw-bold fs-5 mb-4 color-plum text-center d-block">
                      {t("introduceText")}
                    </label>
                    <textarea
                      className="form-control"
                      id="text"
                      rows="7"
                      name="text"
                      style={{ borderRadius: '24px', padding: '20px', backgroundColor: '#fcfcfc', border: '2px solid #f0f0f0' }}
                      maxLength={values.limit}
                      onChange={values.handleChange}
                      value={values.form.text}
                    ></textarea>
                     <div className="text-end mt-2">
                      <small className="text-muted">{values.form.text.length} / {values.limit}</small>
                    </div>
                    
                    <div className="position-relative my-5">
                      <hr className="opacity-10" />
                      <span className="position-absolute top-50 start-50 translate-middle bg-white px-4 text-muted fw-bold small text-uppercase" style={{ letterSpacing: '2px' }}>
                        {t("or")}
                      </span>
                    </div>
                    
                    <FileUpload 
                      onTextExtracted={values.handleFileTextExtracted}
                      disabled={values.isGenerating}
                    />
                  </div>

                  <div className="row g-4 mb-5">
                    <div className="col-md-4">
                      <label className="form-label fw-bold small text-uppercase color-plum">{t("selectQuestionType")}</label>
                      <select className="form-select modern-select" value={values.form.questionType} onChange={values.handleChange} name="questionType">
                        <option value="-1">{t("select")}</option>
                        <option value="MCQ">{t("multipleChoice")}</option>
                        <option value="TF">{t("trueFalse")}</option>
                        <option value="open">{t("openAnswer")}</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small text-uppercase color-plum">{t("selectDifficulty")}</label>
                      <select className="form-select modern-select" value={values.form.difficulty} onChange={values.handleChange} name="difficulty">
                        <option value="-1">{t("select")}</option>
                        <option value="fácil">{t("easy")}</option>
                        <option value="medio">{t("medium")}</option>
                        <option value="difícil">{t("difficult")}</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small text-uppercase color-plum">{t("limitQuestions")}</label>
                      <input type="number" className="form-control" name="number" min={0} max={10} onChange={values.handleChange} value={values.form.number || 0} />
                    </div>
                  </div>

                  <div className="mb-5 text-center">
                    <label className="form-label fw-bold small text-uppercase color-plum d-block mb-3">{t("selectLanguage")}</label>
                    <div className="d-flex justify-content-center gap-3">
                       {['Spanish', 'English', 'Tamil'].map(lang => (
                        <button 
                          key={lang}
                          type="button"
                          className={`btn-3 btn-sm py-2 px-4 ${values.form.language === lang ? 'active' : ''}`}
                          onClick={() => values.handleChange({ target: { name: 'language', value: lang } })}
                        >
                          {t(lang.toLowerCase())}
                        </button>
                       ))}
                    </div>
                  </div>

                  <div className="text-center mb-5">
                    <button
                      disabled={values.isGenerating}
                      onClick={values.handleGenerateQA}
                      type="button"
                      className="btn-2 px-5 py-3 w-100 shadow-sm"
                    >
                      {values.isGenerating ? t("generating") : (values.qaPairs?.length > 0 ? t("regenerate") : t("generateQuestions"))}
                    </button>
                  </div>

                  {values.qaPairs?.length > 0 && (
                    <div className="results-section mt-5 border-top pt-5">
                       <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="fw-bold color-plum mb-0">{t("results")}</h4>
                         {values.checked?.length > 0 && (
                           <button 
                             onClick={values.handleDelete} 
                             type="button" 
                             className="d-flex align-items-center gap-2 transition-all" 
                             style={{ 
                               background: 'rgba(220, 53, 69, 0.1)',
                               color: '#dc3545',
                               border: '1px solid rgba(220, 53, 69, 0.2)',
                               borderRadius: '50px',
                               padding: '4px 12px',
                               fontSize: '0.7rem',
                               fontWeight: '700',
                               cursor: 'pointer'
                             }}
                           >
                             <BiTrash size={12} /> {t("removeSelected")?.toUpperCase()}
                           </button>
                         )}
                      </div>
                      
                      <div className="modern-qa-container">
                        {values.qaPairs.map((element, index) => (
                          <div key={index} className="modern-qa-card mb-4">
                             <div className="qa-header-custom d-flex align-items-center gap-3">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={values.isChecked[index]}
                                  onChange={(event) => values.handleCheck(event, index)}
                                  style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                />
                                <span className="fw-bold color-plum fs-5 flex-grow-1">{index + 1}. {element.question}</span>
                             </div>
                             <div className="qa-body-custom">
                               {values.form.questionType === "MCQ" && element.options && (
                                  <div className="mb-4">
                                     <label className="qa-label">{t("options")}</label>
                                     <ul className="qa-options-list">
                                       {element.options.map((op, i) => (
                                         <li key={i} className="qa-option-item">{op}</li>
                                       ))}
                                     </ul>
                                  </div>
                               )}
                               <div className="qa-answer-box">
                                 <label className="qa-label text-success opacity-100 mb-1">{t("answer")}</label>
                                 <p className={`qa-answer-text mb-0 ${element.answer === false ? 'text-danger' : ''}`}>
                                   {element.answer === true ? t("true") : (element.answer === false ? t("false") : element.answer)}
                                 </p>
                               </div>
                             </div>
                          </div>
                        ))}
                      </div>

                      <div className="d-flex flex-column flex-md-row gap-3 mt-4">
                        <button onClick={() => generatePDF(values.qaPairs, true, values.form.language)} type="button" className="btn-pdf-modern flex-grow-1" disabled={values.qaPairs.length === 0}>
                           <AiOutlineFilePdf size={22} /> {t("generatePDFWithAnswers")}
                        </button>
                        <button onClick={() => generatePDF(values.qaPairs, false, values.form.language)} type="button" className="btn-pdf-modern flex-grow-1" disabled={values.qaPairs.length === 0}>
                           <AiOutlineFilePdf size={22} /> {t("generatePDFNoAnswers")}
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="row g-3 mt-5 justify-content-center border-top pt-5">
                    <div className="col-md-4">
                      <button disabled={values.isGenerating} type="submit" className="btn-form-save w-100 py-3">
                        {values.id ? t("update") : t("save")}
                      </button>
                    </div>
                    <div className="col-md-4">
                      <button disabled={values.isGenerating} type="button" onClick={values.handleReset} className="btn-form-reset w-100 py-3">
                        {values.id ? t("reset") : t("clear")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        )}

        {values.form.format === "blooms" && (
           <div className="fade-in">
             <div className="modern-card mb-4" style={{ backgroundColor: 'rgba(0, 150, 255, 0.05)', border: '1px dashed var(--pastel-blue)' }}>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <BiInfoCircle size="24" className="text-primary" />
                  <span className="fw-medium text-primary">{t("bloomsModuleInfo")}</span>
                </div>
              </div>

              <div className="modern-card">
                 <form className="mx-auto" style={{ maxWidth: '800px' }} onSubmit={values.handleSubmit}>
                  <div className="mb-5">
                    <label htmlFor="text" className="form-label fw-bold fs-5 mb-4 color-plum text-center d-block">
                      {t("introduceText")}
                    </label>
                    <textarea
                      className="form-control"
                      id="text"
                      rows="7"
                      name="text"
                      style={{ borderRadius: '24px', padding: '20px', backgroundColor: '#fcfcfc', border: '2px solid #f0f0f0' }}
                      maxLength={values.limit}
                      onChange={values.handleChange}
                      value={values.form.text}
                    ></textarea>
                    
                    <div className="position-relative my-5">
                      <hr className="opacity-10" />
                      <span className="position-absolute top-50 start-50 translate-middle bg-white px-4 text-muted fw-bold small text-uppercase" style={{ letterSpacing: '2px' }}>
                        {t("or")}
                      </span>
                    </div>
                    
                    <FileUpload 
                      onTextExtracted={values.handleFileTextExtracted}
                      disabled={values.isGenerating}
                    />
                  </div>

                  <div className="mb-5">
                    <label className="form-label fw-bold small text-uppercase color-plum d-block mb-4 text-center">{t("selectLevels")}</label>
                    <div className="row g-3">
                       {["crear", "evaluar", "analizar", "aplicar", "entender", "recordar"].map((lvl, i) => (
                        <div key={lvl} className="col-6 col-md-4">
                          <div className={`p-3 border rounded-4 text-center transition-all ${values.isCheckedLevels[i] ? 'border-primary bg-light shadow-sm' : ''}`} style={{ cursor: 'pointer' }} onClick={() => values.handleCheckLevels({ target: { checked: !values.isCheckedLevels[i] } }, i)}>
                             <input type="checkbox" className="form-check-input d-none" checked={values.isCheckedLevels[i]} readOnly />
                             <span className={`fw-bold small ${values.isCheckedLevels[i] ? 'text-primary' : 'text-muted'}`}>{t(lvl === 'crear' ? 'create' : (lvl === 'evaluar' ? 'evaluate' : (lvl === 'analizar' ? 'analyze' : (lvl === 'aplicar' ? 'apply' : (lvl === 'entender' ? 'understand' : 'remember')))))}</span>
                          </div>
                        </div>
                       ))}
                    </div>
                  </div>

                  <div className="row g-4 mb-5">
                     <div className="col-md-6">
                        <label className="form-label fw-bold small text-uppercase color-plum">{t("selectDifficulty")}</label>
                        <select className="form-select modern-select" value={values.form.difficulty} onChange={values.handleChange} name="difficulty">
                          <option value="-1">{t("select")}</option>
                          <option value="fácil">{t("easy")}</option>
                          <option value="medio">{t("medium")}</option>
                          <option value="difícil">{t("difficult")}</option>
                        </select>
                     </div>
                     <div className="col-md-6">
                        <label className="form-label fw-bold small text-uppercase color-plum">{t("numQuestionsPerLevelLabel")} (máx 5)</label>
                        <input type="number" className="form-control" name="number" min={1} max={5} onChange={values.handleChange} value={values.form.number || 0} />
                        <small className="text-muted d-block mt-2">{t("questionsPerLevelHelp")}</small>
                        {numLevels > 0 && perLevel > 0 && (
                          <small className="d-block mt-1 fw-bold" style={{ color: 'var(--pink-bright)' }}>
                            {perLevel} × {numLevels} = {totalQuestions} {t("questionsTotalWord")}
                          </small>
                        )}
                     </div>
                  </div>

                  <div className="mb-5 text-center">
                    <label className="form-label fw-bold small text-uppercase color-plum d-block mb-3">{t("selectLanguage")}</label>
                    <div className="d-flex justify-content-center gap-3">
                       {['Spanish', 'English', 'Tamil'].map(lang => (
                        <button
                          key={lang}
                          type="button"
                          className={`btn-3 btn-sm py-2 px-4 ${values.form.language === lang ? 'active' : ''}`}
                          onClick={() => values.handleChange({ target: { name: 'language', value: lang } })}
                        >
                          {t(lang.toLowerCase())}
                        </button>
                       ))}
                    </div>
                  </div>

                  <div className="mb-5 text-center">
                    <button
                      disabled={values.isGenerating}
                      onClick={values.handleBloomsApi}
                      type="button"
                      className="btn-2 px-5 py-3 w-100 shadow-sm"
                    >
                      {values.isGenerating ? t("generating") : (values.qaPairs?.length > 0 ? t("regenerate") : t("generateQuestions"))}
                    </button>
                  </div>

                  {values.qaPairs?.length > 0 && (
                    <div className="results-section mt-5 border-top pt-5">
                       <h4 className="fw-bold color-plum mb-4">{t("results")}</h4>
                        <div className="modern-qa-container">
                         {values.qaPairs.map((element, index) => (
                           <div key={index} className="modern-qa-card mb-4">
                              <div className="qa-header-custom d-flex justify-content-between align-items-center">
                                 <span className="fw-bold color-plum fs-5">{index + 1}. {element.question}</span>
                                 <span className="qa-badge">{element.level?.toUpperCase()}</span>
                              </div>
                              <div className="qa-body-custom">
                                {element.options && (
                                   <div className="mb-4">
                                      <label className="qa-label">{t("options")}</label>
                                      <ul className="qa-options-list">
                                        {element.options.map((op, i) => (
                                          <li key={i} className="qa-option-item">{op}</li>
                                        ))}
                                      </ul>
                                   </div>
                                )}
                                <div className="qa-answer-box">
                                  <label className="qa-label text-success opacity-100 mb-1">{t("answer")}</label>
                                  <p className="qa-answer-text">{element.answer}</p>
                                </div>
                              </div>
                           </div>
                          ))}
                        </div>

                      <div className="d-flex flex-column flex-md-row gap-3 mt-4">
                        <button onClick={() => generatePDF(values.qaPairs, true, values.form.language)} type="button" className="btn-pdf-modern flex-grow-1" disabled={values.qaPairs.length === 0}>
                           <AiOutlineFilePdf size={22} /> {t("generatePDFWithAnswers")}
                        </button>
                        <button onClick={() => generatePDF(values.qaPairs, false, values.form.language)} type="button" className="btn-pdf-modern flex-grow-1" disabled={values.qaPairs.length === 0}>
                           <AiOutlineFilePdf size={22} /> {t("generatePDFNoAnswers")}
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="row g-3 mt-5 justify-content-center border-top pt-5">
                    <div className="col-md-4">
                      <button disabled={values.isGenerating} type="submit" className="btn-form-save w-100 py-3">
                        {values.id ? t("update") : t("save")}
                      </button>
                    </div>
                    <div className="col-md-4">
                      <button disabled={values.isGenerating} type="button" onClick={values.handleReset} className="btn-form-reset w-100 py-3">
                        {values.id ? t("reset") : t("clear")}
                      </button>
                    </div>
                  </div>
                 </form>
              </div>
           </div>
        )}
        <Footer logged={values.logged} />
      </main>

      <style>{`
        .color-plum { color: var(--plum-bg); }
        .text-pink { color: var(--pink-bright); }
        .modern-select {
          border-radius: 16px;
          padding: 12px 20px;
          border: 2px solid #f0f0f0;
          background-color: #fcfcfc;
        }
        .modern-select:focus {
          border-color: var(--pink-bright);
          box-shadow: 0 0 0 4px var(--pastel-pink);
        }
        .btn-3.active {
          background-color: var(--plum-bg);
          color: white;
          border-color: var(--plum-bg);
        }
        .fade-in {
          animation: fadeIn 0.5s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default CreateText
